import Vue from 'vue'
import request from '@/helpers/request'
import snack from '@/helpers/snack'

export default {
  GET_GOOD_GIVES: ({ commit, state }, payload) => {
    if (payload.params.offset === 0) {
      commit('setGoodGives', [])
    }

    return new Promise((resolve, reject) => {
      if (payload.showPreloader) {
        commit('setLoad', true)
      }

      request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodGives.all}`,
        {
          params: payload.params,
        },
        true,
      )
        .then(response => {
          if (response.data.result === 'success') {
            const data = response.data.data
            commit('updateGoodGives', data.items)
            commit('setGoodGiveFilters', data.filters)
            commit('setGoodGiveStatuses', data.statuses)
            resolve(data.count)
          }
        })
        .finally(() => {
          if (payload.showPreloader) {
            commit('setLoad', false)
          }
        })
    })
  },
  GET_GOOD_GIVES_BY_TITLE({ commit, state }, params) {
    return request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.goodGives.all}`,
      {
        params,
      },
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        const result = _.map(response.data.data.items, item => {
          item.title = `${item.good.title} ${item.barcode}`
          return item
        })
        commit('setGoodGiveSearched', result)
      }
    })
  },
  CHECK_GOOD_GIVE({ commit, state }, { barcode, params }) {
    return request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.goodGives.check}`.replace('$1', barcode),
      {
        params,
      },
      true,
    )
  },
  GET_GOOD_WEIGHT({ commit, state, rootState }, payload) {
    let wmDomain = rootState?.user?.unit?.settings?.wmBaseUrl || null

    if (wmDomain === null) {
      return null
    }

    if (!_.endsWith(wmDomain, '/')) {
      wmDomain += '/'
    }

    return request('GET', `${wmDomain}${Vue.config.modules.crm.api.goodGives.weight}`, {}, true)
  },
  GET_GOODS_AVAILABLE({ commit, state }, payload) {
    return request('GET', `${Vue.config.server}/${Vue.config.modules.crm.api.goodGives.available}`, payload, true).then(
      response => {
        if (response.data.result === 'success') {
          const result = response.data.data.filter(iter => !!iter.title && iter.title.length)
          commit('setGoodGiveAvailable', result)
        }
      },
    )
  },
  SEND_GOOD_GIVES({ commit, state }, params) {
    return request(
      'POST',
      `${Vue.config.server}/${Vue.config.modules.crm.api.goodGives.process}`,
      {
        params,
      },
      true,
    )
  },
  GET_GOOD_GIVE({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      if (payload.showPreloader) {
        commit('setLoad', true)
      }

      request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodGives.one.replace('$1', payload.item)}`,
        {
          params: {
            with: 'good;employer;unit;store;history.good;history.employer;history.store;history.createdBy',
          },
        },
        true,
      )
        .then(response => {
          if (response.data.result === 'success') {
            const item = response.data.data
            const statuses = response.data.statuses
            commit('setGoodGive', item)
          } else {
            snack.add(Vue.config.localization.ru.notFoundMessage)
          }

          resolve()
        })
        .finally(() => {
          if (payload.showPreloader) {
            commit('setLoad', false)
          }
        })
    })
  },
  UPDATE_GOOD_GIVE: ({ commit, state }, payload) => {
    return new Promise((resolve, reject) => {
      commit('setLoad', true)
      const requestParams = Object.assign(payload.props, {
        with: 'good;employer;unit;store;history.good;history.employer;history.store;history.createdBy',
      })

      request(
        'PUT',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodGives.one.replace('$1', payload.id)}`,
        {
          params: requestParams,
        },
        true,
      ).then(response => {
        if (response.data.result === 'success') {
          commit('changeGoodGive', response.data.data)

          snack.add(Vue.config.localization.ru.savedMessage, 'primary')
        } else {
          snack.add(Vue.config.localization.ru.errorSavingMessage)
        }
      })

      commit('setLoad', false)
      resolve()
    })
  },

  GET_GOOD_GIVE_WITH_EXTRA({ commit, dispatch }, payload) {
    commit('setLoad', true)
    return Promise.all([dispatch('GET_GOOD_GIVE', payload), dispatch('GET_GOOD_GIVES', payload)]).finally(() => {
      commit('setLoad', false)
    })
  },
}
